module.exports = __webpack_public_path__ + "assets/img/icons_chatadd.f4a93aea.svg";